import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';

const stripePublicKey = import.meta.env.VITE_STRIPE_PUBLIC_KEY;

let stripePromise: Promise<Stripe | null>;

export const getStripe = () => {
  if (!stripePromise) {
    if (!stripePublicKey) {
      console.warn('Stripe public key not found. Please set VITE_STRIPE_PUBLIC_KEY.');
      return Promise.resolve(null);
    }
    stripePromise = loadStripe(stripePublicKey);
  }
  return stripePromise;
};

export async function redirectToCheckout(sessionId: string) {
  const stripe = await getStripe();
  if (!stripe) {
    throw new Error('Stripe not initialized');
  }

  // Use window.location for redirect since redirectToCheckout is deprecated
  window.location.href = `/checkout?session_id=${sessionId}`;
}

export async function createCheckoutSession(
  paymentId: string,
  amount: number,
  description: string
): Promise<string | null> {
  try {
    const response = await fetch('/api/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        paymentId,
        amount,
        description,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create checkout session');
    }

    const { sessionId } = await response.json();
    return sessionId;
  } catch (error) {
    console.error('Error creating checkout session:', error);
    return null;
  }
}

export async function createPaymentLink(
  amount: number,
  description: string,
  paymentId: string
): Promise<string | null> {
  try {
    const response = await fetch('/api/create-payment-link', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        amount,
        description,
        paymentId,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to create payment link');
    }

    const { url } = await response.json();
    return url;
  } catch (error) {
    console.error('Error creating payment link:', error);
    return null;
  }
}
